import React, { useContext } from 'react';

import { DataContext3 } from '../contexts/DataContext3';
import CountryPage from './RegistrationSteps.js/CountryPage';
import PhoneNumberPage from './RegistrationSteps.js/PhoneNumberPage';
import SmsConfirmationPage from './RegistrationSteps.js/SmsConfirmationPage';
import FirstNamePage from './RegistrationSteps.js/FirstNamePage';
import LastNamePage from './RegistrationSteps.js/LastNamePage';
import DobPage from './RegistrationSteps.js/DobPage';
import ZipPage from './RegistrationSteps.js/ZipPage';
import EmailPage from './RegistrationSteps.js/EmailPage';
import SubmitPage from './RegistrationSteps.js/SubmitPage';
import DevicesPage from './RegistrationSteps.js/DevicesPage';
import FinishPage from './RegistrationSteps.js/FinishPage';
import MgmPhoneNumberPage from './RegistrationSteps.js/MgmPhoneNumberPage';

const StepsPages = [
  CountryPage,
  MgmPhoneNumberPage,
 // FirstNamePage,
  //LastNamePage,
  //ZipPage,
  //DobPage,
  //EmailPage,
 FinishPage,
];

function RegistrationPage3() {
  const { currentStep } = useContext(DataContext3);
  const PageComponent = StepsPages[currentStep];
  return <PageComponent />;
}

export default RegistrationPage3;
